import { Collapse as AntdCollapse, type CollapseProps } from 'antd'

export const Collapse = (props: CollapseProps) => <AntdCollapse {...props} />
